import * as React from "react";
import { useSearchParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import Chiesa from "../components/Chiesa";
import Parteciperai from "../components/partecipations/Parteciperai";
import { Invitati } from "../components/partecipations/Invitati";
import Mail from "../components/partecipations/Mail";
import Cell from "../components/partecipations/Cell";

import Container from "@mui/material/Container";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "#fff",
  fontFamily: '"Penna"',
  fontSize: "1.8rem",
  fontWeight: "bold",
}));

function RSVP(props) {
  const [searchParams] = useSearchParams();
  const isDone = searchParams.get("completed") || props.isDone;

  const [isComing, setComing] = React.useState(true);

  const handleComingChange = (v) => {
    setComing(v === "yes");
  };

  if(searchParams.get("completed") && !props.isDone) {
    window.location.reload();
  }

  let url = "/form.php";
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    url = "http://localhost:8000/form.php";
  }

  // if (isDone) {
  //   window.location.pathname = "/cerimonia"
  // }

  const placeholderDone = (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      alignItems="center"
      justifyContent="center"
      marginTop="300px"
    >
      <Grid item xs={12} sm={2}>
        <Chiesa specialMsg={isDone}/>
      </Grid>
    </Grid>
  );

  return (
    <Container maxWidth="xl" sx={{ pt: "1em" }}>
    <Box sx={{ width: "100%" }}>
      {isDone && placeholderDone}
      {!isDone && (
        <Item sx={{backgroundColor: "transparent"}}>
        
          <form action={url} method="post">
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              alignItems="center"
            >
              <Grid item xs={12} md={8}>
                <Parteciperai onChange={handleComingChange} />
                <Invitati enabled={isComing} />
                <Mail />
                <Cell />
              </Grid>
              <Grid item md={4} sx={{ display: { xs: "none", md: "flex" } }}>
                <Chiesa />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  marginTop: "10px",
                  backgroundColor: "#aa9b9c",
                  "&:hover": {
                    backgroundColor: "#646954",
                  },
                }}
              >
                Conferma la tua presenza
              </Button>
            </Grid>
            {/* <Grid
              item
              xs={12}
              sx={{ paddingTop: "10px", display: { md: "none" } }}
            >
              <Chiesa />
            </Grid> */}
          </form> 
      </Item>
      )}
    </Box>
    </Container>
  );
}

export default RSVP;
